<template>
  <div class="footer" id="footer">
    <div class="container-lg">
      <div class="main">
        <div class="qr-wrap">
          <div class="bottom-logo-container">
            <img class="bottom-logo" src="../../assets/imgs/common/footer-logo.png">
            <div class="slogan">上上签同业签证平台</div>
          </div>
        </div>
        <div class="help">
          <div class="body">
            <div class="title">签证知识</div>
            <ul class="content">
              <li class="line-box">
                <router-link :to="{ name: 'latestNews' }" class="link">最新资讯</router-link>
              </li>
              <li class="line-box">
                <router-link :to="{ name: 'caseAnalysis' }" class="link">案例解析</router-link>
              </li>
              <li class="line-box">
                <router-link :to="{ name: 'visaOpenClass' }" class="link">签证公开课</router-link>
              </li>
              <li class="line-box">
                <router-link :to="{ name: 'visaGuide' }" class="link">办签指南</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="contacts">
          <div class="body">
            <div class="title">联系我们</div>
            <ul class="content">
              <li class="line-box">
                <span class="line-label">商务合作</span>
                <span class="line-content">高先生&nbsp;gary.gao@idsuipai.com</span>
              </li>
              <li class="line-box">
                <span class="line-label">签证资源合作</span>
                <span class="line-content">王先生&nbsp;pengbo.wang@idsuipai.com</span>
              </li>
              <li class="line-box">
                <span class="line-label">举报邮箱</span>
                <span class="line-content">谢先生&nbsp;gaoyun.xie@idsuipai.com</span>
              </li>
              <li class="line-box">
                <router-link :to="{path: '/about-us'}" class="name-box link">关于我们</router-link>
              </li>
              <li class="line-box">
                <router-link :to="{path: '/about-us', query: { to: 'join' }}" class="detail-box link">加入我们</router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="contacts-phone">
          <div class="body">
            <div class="title">咨询热线</div>
            <ul class="content">
              <li class="line-box">
                <span class="phone">0755-26919327</span>
              </li>
              <li class="line-box">
                <span>周一至周五</span>
              </li>
              <li class="line-box">
                <span>9:00-12:30   14:00-18:30</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="about">
          <div class="body">
            <div class="row">
              <p class="wechat">微信扫码关注</p>
              <div class="qrcode-box">
                <img src="../../assets/imgs/index/wx-qrcode.jpg" class="img-box">
                <p class="tips">获取最新签证资讯</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="friends-box">
          <div class="label">友情链接:</div>
          <ul class="friends">
            <li class="item" v-for="item in friends" :key="item.title">
              <a :class="{'not-link': !item.url}" :href="item.url" target="_blank">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div class="copyright">
          <a class="link" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备16118707号-1</a> Copyright© 深圳市六六六国际旅行社有限公司 2016-{{currentYear}}, 版权所有&nbsp;&nbsp;&nbsp;&nbsp;
          <router-link :to="{ path: '/iso-auth' }" class="link">国际标准ISO27001信息安全管理体系认证</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../../libs/user';
// 友情链接： 美国驻华使领馆    澳大利亚驻华使领馆    加拿大驻华使领馆    德国驻华使领馆    英国驻华使领馆    法国驻华使领馆    日本驻华使领馆    马来西亚驻华使领馆    申请友情链接 zhicheng.ye@idsuipai.com
export default {
  props: ['customer_service'],
  data() {
    return {
      User,
      friends: [
        { title: '美国驻华使领馆', url: 'http://chinese.usembassy-china.org.cn/' },
        { title: '澳大利亚驻华使领馆', url: 'http://china.embassy.gov.au/bjngchinese/home.html' },
        { title: '加拿大驻华使领馆', url: 'http://www.canadainternational.gc.ca/china-chine/contact-contactez.aspx?lang=zh-CN' },
        { title: '德国驻华使领馆', url: 'http://www.peking.diplo.de/Vertretung/peking/zh/Startseite.html' },
        { title: '英国驻华使领馆', url: 'https://www.gov.uk/government/world/organisations/british-embassy-beijing' },
        { title: '法国驻华使领馆', url: 'http://www.ambafrance-cn.org/%E4%B8%BB%E9%A1%B5.html?lang=zh' },
        { title: '日本驻华使领馆', url: 'http://www.cn.emb-japan.go.jp/' },
        { title: '马来西亚驻华使领馆', url: 'http://www.kln.gov.my/web/chn_beijing/home' },
        { title: '申请友情链接 ke.luo@idsuipai.com' },
      ],
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';


  .footer{
    background-color:#2f323b;
    // height:327px;
    padding-top:44px;
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    z-index: 5;
  }

  .main{
    display: flex;
    width: 100%;
  }

  .qr-wrap{
    flex-shrink: 0;
    width:190px;
    text-align: center;
    margin-right: 100px;
    .bottom-logo-container {
      width: 190px;
      text-align: left;
      .bottom-logo{
        width: 180px;
      }
      .slogan {
        margin-top: 16px;
        font-size: 18px;
        line-height: 25px;
        color: #F3F6F9;
        letter-spacing:3px;
        text-align: left;
      }
    }
  }
  .help{
    margin-right: 80px;
    flex-shrink: 0;
  }
  .contacts{
    // margin-right: 80px;
    flex-grow: 1;
  }
  .contacts-phone{
    flex-shrink: 0;
    margin-right: 96px;
  }

  .contacts, .help, .contacts-phone{
    font-size:18px;
    list-style-type: none;
    position: relative;
    .body{
      .title{
        font-size: 16px;
        line-height: 22px;
        color: #F3F6F9;
        padding-bottom: 20px;
      }
      .content{
        font-size: 12px;
        color: #fff;
        line-height: 17px;
        .line-box{
          color: #C9CDD1;
          padding-bottom: 12px;
          display: flex;
          align-items: flex-start;
          .line-label{
            width: 75px;
            flex-shrink: 0;
          }
          .line-content{
            margin-left: 8px;
            flex-grow: 1;
            overflow: hidden;
          }
          .phone{
            white-space: nowrap;
            color: #F3F6F9;
            font-size: 28px;
            line-height: 32px;
          }
          .link{
            color: #C9CDD1;
            &:hover{
              color: @new-blue;
            }
          }
        }
      }
    }
    .row a:hover{
      color:white;
    }
  }

  .row{
    position:relative;
  }

  .row+.row{
    margin-top:35px;
  }

  .about{
    flex-shrink: 0;
    text-align:center;
    .row{
      align-items:center;
      text-align: center;
      display: flex;
      flex-direction: column;
      .wechat{
        color: #F3F6F9;
        font-size: 16px;
        line-height: 22px;
      }
      .qrcode-box{
        margin-top: 12px;
        width: 120px;
        height: 140px;
        background: #fff;
        font-size: 0;
        .img-box{
          display:inline-block;
          width:120px;
          height:120px;
        }
        .tips{
          color:#2F333D;
          font-size: 12px;
          line-height: 17px;
        }
      }

    }
  }

  .bottom{
    color:rgba(255,255,255,0.4);
    font-size:14px;
    padding: 30px 0 24px 0;
    // position:absolute;
    bottom:24px;
    left:0;
    right:0;
    font-size: 12px;
    color: #91999F;
    .friends-box{
      display: flex;
      margin-bottom:16px;
      .label{
        flex-shrink: 0;
        margin-right: 0;
      }
    }
    .copyright {
      text-align: center;
      font-size: 12px;
      .link{
        color:rgba(255,255,255,0.4);
        &:hover{
          color: @new-blue;
        }
      }
    }
  }

  .friends{
    li{
      display:inline-block;
      padding:0 10px;
      color: #91999F;
      &+li{
        border-left:1px solid #91999F;
      }
      a{
        color:#91999F;
        cursor: pointer;
        &.not-link{
          cursor: default;
          &:hover{
            color: #91999F;
          }
        }
        &:hover{
          color: @new-blue;
        }
      }
    }


  }



</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue